import api from "./api";

export default class SalesListAPI {
  static getSalesList = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    search: string,
    idCliente: number,
    valorInicio: number,
    valorFim: number,
    idStatus: number,
    ModoPgto: number
  ) => {
    const response = await api.get(
      `/Transacao/consulta/cliente?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&Search=${search}&idCliente=${idCliente}&valorInicio=${valorInicio}&valorFim=${valorFim}&idStatus=${idStatus}&ModoPgto=${ModoPgto}`
    );
    return response;
  };

  static getSalesListDashboard = async (
    page: number,
    RecordsPerPage: number,

    search: string,
    idCliente: number,
    valorInicio: number,
    valorFim: number,
    idStatus: number,
    ModoPgto: number
  ) => {
    const response = await api.get(
      `/Transacao/consulta/cliente?Page=${page}&RecordsPerPage=${RecordsPerPage}&Search=${search}&idCliente=${idCliente}&valorInicio=${valorInicio}&valorFim=${valorFim}&idStatus=${idStatus}&ModoPgto=${ModoPgto}`
    );
    return response;
  };

  static exportDetailedExtract = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Extrato/download/detalhado/cliente?dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };

  static exportDetailedExtractFuture = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Extrato/download/detalhado/cliente?dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}&Futuro=${true}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };
}
